export default "__VITE_ASSET__fee1a002__"